import { changeCustomerShipToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";
import { css } from "styled-components";

changeCustomerShipToSelectorStyles.shipToSelectorDynamicDropdown = {
    cssOverrides: {
        list: css`
            overflow-y: scroll;
            max-height: 200px;
        `,
    },
};
